
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./HelpDrawer": () => {
return __webpack_require__.e(/*  | __federation_expose_HelpDrawer */ "58995").then(() => (() => (__webpack_require__(53413))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };